export default function getResource(label, vars = []) {
    const resources = {
        mostPositiveReview: 'Commentaire positif le plus utile',
        mostNegativeReview: 'Commentaire critique le plus utile',
        mostHelpfulReview: 'Commentaire le plus utile',
        ratingsReviews: 'Évaluations et commentaires',
        writeReview: 'Rédiger un commentaire',
        reviewsFromTo: `Commentaires ${vars[0]}–${vars[1]} sur ${vars[2]}`,
        reviewsFromToMentioning: `Commentaires ${vars[0]} à ${vars[1]} sur ${vars[2]} mentionnant`,
        searchResult: `${vars[0]} Commentaire contenant « ${vars[1]} »`,
        searchResults: `${vars[0]} Commentaires contenant « ${vars[1]} »`,
        noSearchResult: `Désolés, aucun commentaire contenant « ${vars[0]} »`,
        noReview: 'Désolé, aucun avis ne correspond aux filtres appliqués. Essayez de retirer certains filtres.',
        showingReviewsMentioning: `Afficher les avis mentionnant « ${vars[0]} »`,
        page: 'Page',
        nextPage: 'Page suivante',
        previousPage: 'Page précédente'
    };
    return resources[label];
}
